import React, { Suspense, lazy } from 'react';
import Split from '../split';
import LegacyIntercomButton from './LegacyIntercomButton';

const LegacyGleapButton = lazy(() => import('./LegacyGleapButton'));

const LegacySupportButton = () => {
    if (Split.getBooleanTreatment('use_gleap_support_widget')) {
        return (
            <Suspense fallback={null}>
                <LegacyGleapButton />
            </Suspense>
        );
    }
    return <LegacyIntercomButton />;
};

export default LegacySupportButton;
